import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'

type AuthSliceState = { user: {} | null, token: string | null, erik_token: string | null, erik_url: string | null }

const authSlice = createSlice({
    name: 'auth',
    initialState: { user: null, token: null, erik_url: null, erik_token: null } as AuthSliceState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ user: {} }>) => {
            const { user } = action.payload
            state.user = user
        },
        setAIAgentCredentials: (state, action: PayloadAction<{token: string | null, erik_url: string | null}>) => {
            const {token, erik_url} = action.payload
            state.erik_token = token
            state.erik_url = erik_url
        }
    }
})

export const { setAIAgentCredentials } = authSlice.actions
export default authSlice.reducer
export const selectCurrentErikToken = (state: RootState) => state.auth.erik_token
export const selectCurrentErikUrl = (state: RootState) => state.auth.erik_url